
import { DatePicker as AntdDatePicker } from 'antd';
import type { RangePickerProps } from 'antd/es/date-picker';
import { useId } from 'react';
import cn from 'classnames';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/ru';

import { DatePickerFormat } from '../model/format';
import { parseDateValue } from '../lib/parseDateValue';

import styles from './AppDatePicker.module.scss';

dayjs.locale('ru');

type AppRangePickerProps = Omit<
  RangePickerProps,
  'format' | 'placeholder'
> & {
  placeholder?: [string, string];
  format?: DatePickerFormat;
  mask?: boolean;
  error?: string;
  invalid?: boolean;
};

const { RangePicker: AntdRangePicker } = AntdDatePicker;

const AppRangePicker = ({
    className,
    placeholder = ['Начало', 'Конец'],
    value,
    onChange,
    format = DatePickerFormat.DATE,
    mask = true,
    maxDate,
    disabled,
    error,
    invalid = false,
    id,
    'aria-describedby': ariaDescribedBy,
    ...props
}: AppRangePickerProps) => {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const errorId = `${inputId}-error`;

  const hasError = Boolean(error);
  const isInvalid = invalid || hasError;

  const parsedValue: [Dayjs | null, Dayjs | null] | null = value
    ? [parseDateValue(value[0]), parseDateValue(value[1])]
    : null;

  console.log(parsedValue, value);

  return (
    <div className={styles.wrapper}>
      <AntdRangePicker
        {...props}
        id={inputId}
        separator={<span>-</span>}
        className={cn(
          className,
          styles.input,
          {
            [styles.error]: isInvalid,
          }
        )}
        placeholder={placeholder}
        format={
          mask
            ? { format, type: 'mask' }
            : format
        }
        onChange={onChange}
        value={parsedValue}
        maxDate={maxDate}
        disabled={disabled}
        aria-invalid={isInvalid || undefined}
        aria-describedby={
          [
            ariaDescribedBy,
            hasError ? errorId : undefined,
          ]
            .filter(Boolean)
            .join(' ') || undefined
        }
      />

      {hasError && (
        <div
          id={errorId}
          className={styles.errorMessage}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export { AppRangePicker };
